/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import {
  closeModal, speak, toggleAlwaysPopup, updateSpeed,
} from '../../actions';
import X from '../../assets/login/x.svg';

const MissingSurvey = (props) => {
  return (
    <div className="accessibility-modal">
      <img onClick={props.closeModal} className="accessibility-x-icon" src={X} alt="x" />
      <h2 onClick={props.speak} className={`tts-header ${props.speechEnabled && 'bolded'}`}>
        Missing Survey
      </h2>
      <div className="tts-body">
        <p onClick={props.speak} className={`${props.speechEnabled && 'bolded'}`}>
          Uh oh! Looks like you&apos;ve chosen a survey that&apos;s still under construction. Please choose a finished survey like, &quot;How I Approach My Work&quot;.
        </p>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => (
  {
    speechAlwaysPopup: state.speech.alwaysPopup,
    speechEnabled: state.speech.enabled,
    speed: state.speech.speed,
  }
);

export default connect(mapStateToProps, {
  closeModal, speak, toggleAlwaysPopup, updateSpeed,
})(MissingSurvey);
